import { BUTTON_SIZES, BUTTON_VARIANTS, Button } from 'ui/button';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { ModalType, useModalContext } from '../../context';

export const SCHEDULE_UNSAVED_CHANGES_MODAL_TEST_ID = 'schedule-unsaved-changes-modal';
export const SCHEDULE_UNSAVED_CHANGES_KEEP_CHANGES_BUTTON_TEST_ID = `${SCHEDULE_UNSAVED_CHANGES_MODAL_TEST_ID}-keep-changes-button`;
export const SCHEDULE_UNSAVED_CHANGES_DISCARD_BUTTON_TEST_ID = `${SCHEDULE_UNSAVED_CHANGES_MODAL_TEST_ID}-discard-button`;

export const ScheduleUnsavedChangesModal = () => {
  const { closeModal } = useModalContext();

  return (
    <Modal
      withPortal
      isModalOpen
      id="schedule-unsaved-changes-modal"
      data-test={SCHEDULE_UNSAVED_CHANGES_MODAL_TEST_ID}
      onClose={() => {
        closeModal(ModalType.ScheduleUnsavedChangesModal);
      }}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader>Unsaved changes</ModalHeader>
      <ModalBody>
        <div>
          This campaign&apos;s schedule has been edited. Are you sure you want to discard your
          changes?
        </div>
      </ModalBody>
      <ModalFooter hasCancel={false}>
        <Button
          variant={BUTTON_VARIANTS.GHOST}
          onClick={() => {
            closeModal(ModalType.ScheduleUnsavedChangesModal);
          }}
          data-test={SCHEDULE_UNSAVED_CHANGES_KEEP_CHANGES_BUTTON_TEST_ID}
          size={BUTTON_SIZES.LARGE}
        >
          Cancel
        </Button>
        <Button
          variant={BUTTON_VARIANTS.DESTRUCTIVE}
          onClick={() => {
            closeModal(ModalType.ScheduleUnsavedChangesModal);
            closeModal(ModalType.ScheduleCampaign);
            closeModal(ModalType.DisplayEligibilityCampaign);
          }}
          data-test={SCHEDULE_UNSAVED_CHANGES_DISCARD_BUTTON_TEST_ID}
          size={BUTTON_SIZES.LARGE}
        >
          Discard changes
        </Button>
      </ModalFooter>
    </Modal>
  );
};
